import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconMapMarkerL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import {
    resolveLocationDescriptionHorse,
    resolveLocationDescriptionRider,
    showSection,
} from '../utils';
import config from '../../../config';
import { trimDisplayNameLastWord } from '../../../util/text';

const {
    listingTypeHorse,
    listingTypeRider,
    listingTypePrivateHorse,
    listingTypePrivateRider,
} = config;

const SectionLocation = () => {
    const { scoreData, categorySelected, currentPageListing, riderListing } = useContext(
        MatchingDialogContext
    );
    const scoreLocationData = scoreData?.baseScoreBreakdown?.distanceAndMobilityScore;

    if (!scoreLocationData) return null;

    const { distanceInKM = 100 } = scoreLocationData || {};

    const radiusDefined = riderListing?.attributes?.publicData?.user_mobility?.radius;
    /**
     * Only one section Location or Radius,
     * the latter has the highest prio
     */
    if (radiusDefined) return null;

    const { isHighScore, isLowScore, isMidScore, shouldBeShown } = showSection({
        categorySelected,
        ...scoreLocationData,
    });

    if (!shouldBeShown) return null;

    const { title, publicData } = currentPageListing?.attributes || {};
    const { type } = publicData || {};

    const isHorseListing = type === listingTypeHorse || type === listingTypePrivateHorse;
    const isRiderListing = type === listingTypeRider || type === listingTypePrivateRider;

    const descriptionResolver = isHorseListing
        ? resolveLocationDescriptionRider
        : resolveLocationDescriptionHorse;

    const description = descriptionResolver({
        distanceInKM,
        isHighScore,
        isLowScore,
        isMidScore,
        title: isRiderListing ? trimDisplayNameLastWord(title) : title,
    });

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconMapMarkerL />
                <span>Standort</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={scoreLocationData} />
            <SectionBlock.Description>{description}</SectionBlock.Description>
        </SectionBlock>
    );
};

export default SectionLocation;
